/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FlightCredit } from './FlightCredit';
import {
    FlightCreditFromJSON,
    FlightCreditFromJSONTyped,
    FlightCreditToJSON,
    FlightCreditToJSONTyped,
} from './FlightCredit';

/**
 * 
 * @export
 * @interface FlightCreditsResponse
 */
export interface FlightCreditsResponse {
    /**
     * 
     * @type {Array<FlightCredit>}
     * @memberof FlightCreditsResponse
     */
    credits?: Array<FlightCredit>;
}

/**
 * Check if a given object implements the FlightCreditsResponse interface.
 */
export function instanceOfFlightCreditsResponse(value: object): value is FlightCreditsResponse {
    return true;
}

export function FlightCreditsResponseFromJSON(json: any): FlightCreditsResponse {
    return FlightCreditsResponseFromJSONTyped(json, false);
}

export function FlightCreditsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightCreditsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'credits': json['credits'] == null ? undefined : ((json['credits'] as Array<any>).map(FlightCreditFromJSON)),
    };
}

export function FlightCreditsResponseToJSON(json: any): FlightCreditsResponse {
    return FlightCreditsResponseToJSONTyped(json, false);
}

export function FlightCreditsResponseToJSONTyped(value?: FlightCreditsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'credits': value['credits'] == null ? undefined : ((value['credits'] as Array<any>).map(FlightCreditToJSON)),
    };
}

